import {Modal} from "bootstrap";
import {ajaxGet} from "../shared/ajax";

const initAgeVerifyModal = () => {

    if (window.location.search.includes('age_verify=1')) {
        ajaxGet({ url: '/api/set-cookie/av_', processSuccessCallback: false })
    }

    const element = document.querySelector('#age_verify_modal');

    if (element) {
        const modal = new Modal(element, { backdrop: 'static', keyboard: false })
        element.style.backdropFilter = 'blur(6px)';
        modal.show()


        const agreeLinkElement = document.querySelector('#age_verify_modal .agree-link');
        agreeLinkElement.addEventListener('click', function(e) {
            e.preventDefault()
            const link = agreeLinkElement.href
            ajaxGet({ url: link, processSuccessCallback: false })
            modal.hide()
        });
    }
}

export default initAgeVerifyModal;